module.exports = __webpack_public_path__ + "img/browse.4954ceb2.svg";